import { getGlobalConfig } from "../../config/ConfigContext";
import {
  CollectionList,
  Payment,
  PaymentList,
  ResponsePutPayment,
  UserProfile,
  ResponsePaymentTypeList,
  ResponseUserList,
  MassivePaymentUpload,
  MassivePaymentUploadResponse
} from "../../types-interfaces/interfaces";
import { ResponseConciliationManual } from "../../types-interfaces/types";

function headers(token: string, mail: string) {
  let header: HeadersInit = {
    "Content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${token}`,
    email: `${mail}`,
  };
  return header;
}

export async function getCollectionList(
  params: string,
  token: string,
  mail: string
): Promise<CollectionList | string> {
  const config = getGlobalConfig();
  const result = await fetch(
    `${config.BASE_URL_API_SSRR}/${config.VERSION_API_SSRR}/${config.ENDPOINT_COLLECTION_LIST}?${params}`,
    {
      method: "GET",
      headers: headers(token, mail),
    }
  )
    .then((response) => {
      return response.ok ? response.json() : "error"; //TODO: controlar error  400 y 500 si corresponde
    })
    .catch((error) => {
      return error;
    });
  return result;
}

export async function getPaymentList(
  params: string,
  token: string,
  mail: string
): Promise<PaymentList | string> {
  const config = getGlobalConfig();
  const result = await fetch(
    `${config.BASE_URL_API_SSRR}/${config.VERSION_API_SSRR}/${config.ENDPOINT_PAYMENT_LIST}?${params}`,
    {
      method: "GET",
      headers: headers(token, mail),
    }
  )
    .then((response) => {
      return response.ok ? response.json() : "error"; //TODO: controlar error  400 y 500 si corresponde
    })
    .catch((error) => {
      return error;
    });
  return result;
}

export async function PutPayment(
  payment: Payment,
  token: string,
  mail: string
): Promise<ResponsePutPayment | string> {
  const config = getGlobalConfig();
  const result = await fetch(
    `${config.BASE_URL_API_SSRR}/${config.VERSION_API_SSRR}/${config.ENDPOINT_PAYMENT}`,
    {
      method: "POST",
      headers: headers(token, mail),
      body: JSON.stringify(payment),
    }
  )
    .then((response) => {
      return response.ok ? response.json() : "error"; //TODO: controlar error  400 y 500 si corresponde
    })
    .catch((error) => {
      return error;
    });
  return result;
}

export async function GetUser(
  token: string,
  email: string
): Promise<UserProfile | string> {
  const config = getGlobalConfig();
  const result = await fetch(
    `${config.BASE_URL_API_SSRR}/${config.VERSION_API_SSRR}/${config.ENDPOINT_USER_BY_EMAIL}/${email.toLowerCase()}`,
    {
      method: "GET",
      headers: headers(token, email),
    }
  )
    .then((response) => {
      return response.ok ? response.json() : "error"; //TODO: controlar error  400 y 500 si corresponde
    })
    .catch((error) => {
      return error;
    });
  return result;
}

export async function paymentUpdateStatus(
  payload: { paymentIds: Array<string>; newStatus: number },
  token: string,
  mail: string
): Promise<Array<string> | string> {
  const config = getGlobalConfig();
  const result = await fetch(
    `${config.BASE_URL_API_SSRR}/${config.VERSION_API_SSRR}/${config.ENDPOINT_PAYMENT_UPDATE_STATUS}`,
    {
      method: "PATCH",
      headers: headers(token, mail),
      body: JSON.stringify(payload),
    }
  )
    .then((response) => {
      return response.ok ? response.json() : "error"; //TODO: controlar error  400 y 500 si corresponde
    })
    .catch((error) => {
      return "error"; //TODO: controlar mensaje de errores
    });
  return result;
}

export async function conciliationManual(
  payload: { paymentIds: Array<string>; collectionId: string },
  token: string,
  mail: string
): Promise<ResponseConciliationManual | string> {
  const config = getGlobalConfig();
  const result = await fetch(
    `${config.BASE_URL_API_SSRR}/${config.VERSION_API_SSRR}/${config.ENDPOINT_CONCILIATION_MANUAL}`,
    {
      method: "POST",
      headers: headers(token, mail),
      body: JSON.stringify(payload),
    }
  )
    .then((response) => {
      return response.ok ? response.json() : "error"; //TODO: controlar error  400 y 500 si corresponde
    })
    .catch((error) => {
      return "error"; //TODO: controlar mensaje de errores
    });
  return result;
}

export async function CollectionLink(
  payload: { paymentIds: Array<string> },
  token: string,
  mail: string
): Promise<Array<string> | string> {
  const config = getGlobalConfig();
  const result = await fetch(
    `${config.BASE_URL_API_SSRR}/${config.VERSION_API_SSRR}/${config.ENDPOINT_COLLECTION_LINK}`,
    {
      method: "PATCH",
      headers: headers(token, mail),
      body: JSON.stringify(payload),
    }
  )
    .then((response) => {
      return response.ok ? response.json() : "error"; //TODO: controlar error  400 y 500 si corresponde
    })
    .catch((error) => {
      return "error"; //TODO: controlar mensaje de errores
    });
  return result;
}

export async function getPaymentTypeList(
  token: string,
  mail: string
): Promise<ResponsePaymentTypeList> {
  const config = getGlobalConfig();
  const result = await fetch(
    `${config.BASE_URL_API_SSRR}/${config.VERSION_API_SSRR}/${config.ENDPOINT_PAYMENT_TYPE_LIST}`,
    {
      method: "GET",
      headers: headers(token, mail)
    }
  )
    .then((response) => {
      return response.ok ? response.json() : "error"; //TODO: controlar error  400 y 500 si corresponde
    })
    .catch((error) => {
      return "error"; //TODO: controlar mensaje de errores
    });
  return result;
}

export async function paymentUpdateStatusAction(
  payload: { paymentIds: Array<string>; action: number },
  token: string,
  mail: string
): Promise<Array<string> | string> {
  const config = getGlobalConfig();
  const result = await fetch(
    `${config.BASE_URL_API_SSRR}/${config.VERSION_API_SSRR}/${config.ENDPOINT_PAYMENT_UPDATE_STATUS}`,
    {
      method: "PATCH",
      headers: headers(token, mail),
      body: JSON.stringify(payload),
    }
  )
    .then((response) => {
      return response.ok ? response.json() : "error"; //TODO: controlar error  400 y 500 si corresponde
    })
    .catch((error) => {
      return "error"; //TODO: controlar mensaje de errores
    });
  return result;
}

export async function getPaymentUserList(
  params: string,
  token: string,
  mail: string
): Promise<ResponseUserList> {
  const config = getGlobalConfig();
  const result = await fetch(
    `${config.BASE_URL_API_SSRR}/${config.VERSION_API_SSRR}/${config.ENDPOINT_USER_PAYER_LIST}?${params}`,
    {
      method: "GET",
      headers: headers(token, mail)
    }
  )
    .then((response) => {
      return response.ok ? response.json() : "error"; //TODO: controlar error  400 y 500 si corresponde
    })
    .catch((error) => {
      return "error"; //TODO: controlar mensaje de errores
    });
  return result;
}

export async function checkAuth(
  token: string,
  mail: string
): Promise<string | number> {
  const config = getGlobalConfig();
  const result = await fetch(
    `${config.BASE_URL_API_SSRR}/${config.VERSION_API_SSRR}/${config.ENDPOINT_USER_AUTH_CHECK}`,
    {
      method: "GET",
      headers: headers(token, mail)
    }
  )
    .then((response) => {
      return response.status;
    })
    .catch((error) => {
      return "error"; //TODO: controlar mensaje de errores
    });
  return result;
}

export async function massivePaymentUploadFile(
  payload: MassivePaymentUpload,
  token: string,
  mail: string
): Promise<MassivePaymentUploadResponse> {
  const config = getGlobalConfig();
  const result = await fetch(
    `${config.BASE_URL_API_SSRR}/${config.VERSION_API_SSRR}/${config.ENDPOINT_PAYMENT_UPLOAD}`,
    {
      method: "POST",
      headers: headers(token, mail),
      body: JSON.stringify(payload),
    }
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      return "error"; //TODO: controlar mensaje de errores
    });
  return result;
}